module.exports = __webpack_public_path__ + "img/nongshi.f39a5177.png";